import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { Image } from 'react-native';

import ActionButton from 'components/action-button';

import { IBraintreeButton } from './types';

const appleLogo = require('../../../../ucl/themes/shared/icons/ApplePayMark.png');

export const StyledButton = makeUclComponent(ActionButton).withConfig({
  height: '44px',
  accessible: true,
  accessibilityRole: 'button',
  accessibilityLabel: 'Apple Pay',
  _text: {
    fontSize: 'xl',
    textAlign: 'center',
    color: '#FFF',
  },
  backgroundColor: '#000000',
  padding: 0,
});

export const ApplePayButton: React.FC<IBraintreeButton> = ({
  onPress,
  isLoading,
}: IBraintreeButton) => {
  return (
    <StyledButton
      isLoading={isLoading}
      fullWidth
      onPress={onPress}
      rightIcon={
        <Image
          style={{ height: 25, ...({ pointerEvents: 'none' } as any) }}
          resizeMode="contain"
          source={appleLogo}
        />
      }
      padding={isLoading ? 3 : 0}
    />
  );
};
